import { t } from './i18n.js';
import { useEffect, useState } from 'react';
import { send } from './api.js';
import { Notice } from './components.js';
export function CalendarInvitation({ token }: { token: string }) {
  const [data, setData] = useState<any>(),
    [error, setError] = useState(''),
    [busy, setBusy] = useState(false);
  useEffect(() => {
    void send('/calendar/guest/invitation', { token })
      .then(setData)
      .catch((e) => setError(e.message));
  }, [token]);
  const respond = async (response: string) => {
    setBusy(true);
    setError('');
    try {
      setData(await send('/calendar/guest/response', { token, response }));
    } catch (e: any) {
      setError(e.message);
    } finally {
      setBusy(false);
    }
  };
  return (
    <main className="calendar-workspace">
      <section className="calendar-dialog" style={{ margin: '40px auto' }}>
        <h1>{t('Invitation Vename Mail')}</h1>
        {error && <Notice type="error">{error}</Notice>}
        {data && (
          <>
            <h2>{data.title}</h2>
            <p>
              {data.start.replace('T', ' ')} → {data.end.replace('T', ' ')} · {data.timezone}
            </p>
            <p>{t('Organisateur : {name}', { name: data.organizer })}</p>
            <p>{data.location}</p>
            <p className="calendar-description">{data.description}</p>
            {data.count > 1 && (
              <p>
                {t('Cette réponse concerne les {n} occurrences de la série.', { n: data.count })}
              </p>
            )}
            <p>
              {t('Vous répondez en tant que')} <strong>{data.email}</strong>.
            </p>
            <p>
              {t('Réponse :')}{' '}
              {
                (
                  {
                    'needs-action': t('En attente'),
                    accepted: t('Accepté'),
                    declined: t('Refusé'),
                    tentative: t('Provisoire'),
                  } as any
                )[data.response]
              }
            </p>
            <div className="calendar-actions">
              {['accepted', 'tentative', 'declined'].map((r, i) => (
                <button
                  key={r}
                  disabled={busy}
                  className={i === 0 ? 'primary' : 'secondary'}
                  onClick={() => void respond(r)}
                >
                  {[t('Accepter'), t('Peut-être'), t('Refuser')][i]}
                </button>
              ))}
            </div>
          </>
        )}
      </section>
    </main>
  );
}
